import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useAuth } from "../../contexts/AuthContext";
import * as AuthActions from "../../redux/actions/authAction";

const ProtectedRoute = () => {
    const { currentUser, loading } = useAuth();
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        if (!loading && !currentUser) {
            // Save current URL so after login we redirect back
            sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
            // Open login modal
            dispatch(AuthActions.toggleLoginModal(true));
        }
    }, [loading, currentUser]);

    if (loading) {
        return <div className="loading-spinner">Loading...</div>
    }

    return currentUser ? <Outlet /> : <Navigate to="/" replace />
}

export default ProtectedRoute;
